import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { useSesion } from './nucleo/sesion/ProveedorDeSesion.jsx';

import CuentasYTarjetas from './modulos/cuentas/CuentasYTarjetas.jsx';
import Movimientos from './modulos/movimientos/Movimientos.jsx';
import Presupuesto from './modulos/presupuesto/Presupuesto.jsx';
import Tablero from './modulos/tablero/Tablero.jsx';
import Vencimientos from './modulos/vencimientos/Vencimientos.jsx';

import Acceso from './pantallas/Acceso.jsx';
import Acerca from './pantallas/Acerca.jsx';
import Ajustes from './pantallas/Ajustes.jsx';
import Asistente from './pantallas/Asistente.jsx';
import CategoriaEditar from './pantallas/CategoriaEditar.jsx';
import Categorias from './pantallas/Categorias.jsx';
import Monedas from './pantallas/Monedas.jsx';
import Perfil from './pantallas/Perfil.jsx';
import Sesion from './pantallas/Sesion.jsx';
import SesionFinalizada from './pantallas/SesionFinalizada.jsx';
import SinConexion from './pantallas/SinConexion.jsx';
import UsuariosDelHogar from './pantallas/UsuariosDelHogar.jsx';

/**
 * Solo con sesion iniciada se expone dato de negocio alguno (RF-004). Sin ella,
 * al acceso; sin persona usuaria, al asistente de primer arranque (RF-002).
 */
function ConSesion({ children }) {
  const { cargando, haySesion, requiereConfiguracionInicial } = useSesion();
  const ubicacion = useLocation();

  if (cargando) {
    return <div className="centrado"><div className="aviso i">Abriendo la aplicación…</div></div>;
  }

  if (requiereConfiguracionInicial) return <Navigate to="/asistente" replace />;
  if (!haySesion) return <Navigate to="/acceso" replace state={{ desde: ubicacion.pathname }} />;

  return children;
}

export default function App() {
  return (
    <Routes>
      {/* Pantallas SIN barra de navegación: sin sesión no hay Ajustes (RN-044f). */}
      <Route path="/acceso" element={<Acceso />} />
      <Route path="/asistente" element={<Asistente />} />
      <Route path="/sesion-finalizada" element={<SesionFinalizada />} />

      {/* Núcleo: Ajustes es el único destino con contenido real del 1/5 (RF-031). */}
      <Route path="/ajustes" element={<ConSesion><Ajustes /></ConSesion>} />
      <Route path="/ajustes/perfil" element={<ConSesion><Perfil /></ConSesion>} />
      <Route path="/ajustes/usuarios" element={<ConSesion><UsuariosDelHogar /></ConSesion>} />
      <Route path="/ajustes/monedas" element={<ConSesion><Monedas /></ConSesion>} />
      <Route path="/ajustes/categorias" element={<ConSesion><Categorias /></ConSesion>} />
      <Route path="/ajustes/categorias/nueva" element={<ConSesion><CategoriaEditar /></ConSesion>} />
      <Route path="/ajustes/categorias/:idCategoria" element={<ConSesion><CategoriaEditar /></ConSesion>} />
      <Route path="/ajustes/acerca" element={<ConSesion><Acerca /></ConSesion>} />
      <Route path="/ajustes/conexion" element={<ConSesion><SinConexion /></ConSesion>} />
      <Route path="/sesion" element={<ConSesion><Sesion /></ConSesion>} />

      {/* INCREMENTO 14/16 · RF-208, D-309.a · EL TABLERO YA EXISTE Y ES LA CASA.
          El puente del 08/09 —`/tablero` redirigía a Movimientos mientras el
          Tablero no tenía contenido (D-220, D-222, RN-360)— SE RETIRA: ya hay
          contenido que mostrar y la dirección atiende a su pantalla real.

          El guardia de sesión sigue yendo delante (RN-361): entrar por esta
          dirección sin sesión lleva al acceso, y sin persona configurada, al
          asistente de primer arranque.

          La sección vacía (SeccionDeModulo) sigue SIN MONTARSE y ya no le queda
          ningún lector: el Tablero real no la reutiliza (CA-14-20, D-225). */}
      <Route path="/tablero/*" element={<ConSesion><Tablero /></ConSesion>} />
      {/* Incremento 3/6 ya construido: sustituye a la sección vacía SIN tocar el
          shell ni el registro de secciones (RF-019, RF-059). */}
      <Route path="/movimientos/*" element={<ConSesion><Movimientos /></ConSesion>} />
      {/* Incremento 2/6 ya construido: sustituye a la sección vacía SIN tocar el
          shell ni el registro de secciones (RF-019, RF-042). */}
      <Route path="/cuentas/*" element={<ConSesion><CuentasYTarjetas /></ConSesion>} />
      {/* Incremento 5/6 ya construido: sustituye a la sección vacía SIN tocar el
          shell ni el registro de secciones (RF-019, RF-108). */}
      <Route path="/presupuesto/*" element={<ConSesion><Presupuesto /></ConSesion>} />
      {/* Incremento 6/6 ya construido: sustituye a la sección vacía SIN tocar el
          shell ni el registro de secciones (RF-019, RF-122). El 6/6 NO registra
          sección propia (D-185): su sitio es la pestaña «Vencimientos» del destino
          Cuentas, y este destino —que el núcleo tenía registrado desde el 1/6—
          pinta el mismo módulo con su propia base. */}
      <Route path="/vencimientos/*" element={<ConSesion><Vencimientos base="/vencimientos" /></ConSesion>} />

      {/* RF-208, CA-14-01 · LA PANTALLA DE ARRANQUE VUELVE A SER EL TABLERO, como
          estaba aprobado desde el primer prototipo. La raíz es lo que abre el
          icono instalado en el teléfono, así que este renglón cubre también el
          acceso directo. Sustituye al aterrizaje provisional en Movimientos que
          el 08 puso mientras el Tablero no existía (RF-143, RN-359). */}
      <Route path="/" element={<Navigate to="/tablero" replace />} />
      {/* Una dirección que no coincide con ninguna pantalla aterriza en el
          Tablero, sin pantalla de error (RF-208, CA-14-01). */}
      <Route path="*" element={<Navigate to="/tablero" replace />} />
    </Routes>
  );
}
